module.exports = __webpack_public_path__ + "@/assets/img/xls.85c2738d.svg";